<template>
    <div class="sb-option user-news">
        <div class="p-grid">
            <div class="news-item p-lg-9">
                <Panel>
                    <Card>
                        <template slot="content">
                            <h2>{{ newsItem.info }}</h2>
                            <div class="time">{{ formatDate(newsItem.news_time) }}</div>
                            <div v-html="newsItem.rich" class="body"></div>
                        </template>
                    </Card>

                </Panel>
            </div>

            <div class="more-news p-lg-3">
                <div class="more-news-wrap">
                    <h2>More news</h2>

                    <div class="more-news">
                        <div tabindex="0" v-for="(item, index) in news" :key="item.id" class="news-card" @click="selectNews(index)">
                            <h3>{{ item.info }}</h3>
                            <div class="time">{{ formatDate(newsItem.news_time) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NewsService from '../../service/NewsService';
    export default {
        data() {
            return {
                rich: '',
                id: 1,
                news_time: null,
                page: 0,
                newsItem: { id: 0, news_time: '', info: 'info', rich: 'rich' },
                responsiveOptions: [
                    {
                        breakpoint: '1024px',
                        numVisible: 3,
                        numScroll: 3
                    },
                    {
                        breakpoint: '600px',
                        numVisible: 2,
                        numScroll: 2
                    },
                    {
                        breakpoint: '480px',
                        numVisible: 1,
                        numScroll: 1
                    }
                ],
                news: null,


            }
        },
        created() {
            this.$store.commit('setPageTitle', {pageTitle: 'User news'});
            this.newsService = new NewsService();

        },
        mounted() {
            this.getNews();

        },

        methods: {
            async getNews() {

                this.news = await this.newsService.getNews(5);

                var temp_id = 0;

                temp_id = this.$route.params.id;



                this.newsItem = this.news[temp_id];
                this.newsService.seenNews(this.newsItem.id);
                 
            },

            formatDate(date) {
                var d = new Date(date),
                    months = [
                        "JAN",
                        "FEB",
                        "MAR",
                        "APR",
                        "MAY",
                        "JUN",
                        "JUL",
                        "AUG",
                        "SEPT",
                        "OCT",
                        "NOV",
                        "DEC"
                    ],
                    month = months[(d.getMonth())],
                    day = "" + d.getDate(),
                    year = d.getFullYear();

                if (day.length < 2) day = "0" + day;

                return [day, month, year].join(" ");
            },

            selectNews(index) {

                this.newsItem = this.news[index];
               this.newsService.seenNews(this.newsItem.id);

            },


        }
    }
</script>

<style scoped>
    p {
        margin: 0;
        padding: 0;
    }
</style>